import { render } from "./CreateClinicalCase.vue?vue&type=template&id=68d70b64"
import script from "./CreateClinicalCase.vue?vue&type=script&lang=js"
export * from "./CreateClinicalCase.vue?vue&type=script&lang=js"

import "./CreateClinicalCase.vue?vue&type=style&index=0&id=68d70b64&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__